{
    "Profile_Documents.documents": "Documents",
    "Profile_Documents.action": "Action",
    "Profile_Documents.refreshDocuments": "Refresh Documents",
    "Profile_Documents.generateDocument": "Generate Document",
    "Profile_Documents.sendEmailToClient": "Send Email to Client",
    "Profile_Documents.shareDocuments": "Share Documents",
    "Profile_Documents.regenerateDocuments": "Regenerate Documents",
    "Profile_Documents.policyDocuments": "Policy Documents",
    "Profile_Documents.shared": "Shared",
    "Profile_Documents.upload": "Upload",
    "Profile_Documents.policyAttachments": "Policy Attachments",
    "Profile_Documents.template": "Template:",
    "Profile_Documents.documentsOptional": "Documents (optional)",
    "Profile_Documents.cancel": "Cancel",
    "Profile_Documents.send": "Send",
    "Profile_Documents.regenerate": "Regenerate",
    "Profile_Documents.selectWhatToGenerate": "Please select what you want to generate",
    "Profile_Documents.generate": "Generate",
    "Profile_Documents.apply": "Apply",
    "Profile_Documents.reason": "Reason:",
    "Profile_Documents.Input.reasonPlaceholder": "Enter your reason here"
}
